const page_contact = document.getElementById("page-contact");

if (page_contact) {
  const form_contact = page_contact.querySelector("#form-contact");
  const button_submit = form_contact.querySelector("#form-contact-btn-submit");
  const honey_pot_field = form_contact.querySelector("#hp");
  const response_message = form_contact.querySelector(".response-message");

  let isBusy = false;

  button_submit.onclick = async (event) => {
    event.preventDefault();
    // console.log("clicked");

    //% Exit if form submission is in progress
    if (isBusy) {
      return;
    }

    //% Logic when form is busy posting
    isBusy = true;
    response_message.innerText = null;
    form_contact.classList.add("busy");

    const endpoint = window.origin + "/wp-json/contact-form-7/v1/contact-forms/41/feedback";
    const options = {
      method: "POST",
      body: new FormData(form_contact),
    };

    try {
      const response = await submitForm(endpoint, options, honey_pot_field);
      // console.log(response);

      //% Set response message
      response_message.innerText = response?.message || null;

      //% On success
      if (response?.status === "mail_sent") {
        form_contact.reset();
        //% Trigger Event for GA4 Tracking
        triggerEvent(document, "form_submission", form_contact.id);
      }
    } catch (error) {
      //% If spam is detected
      if (error.message === "spam") {
        // console.error("spam");

        //% Lock the form out until page refresh by not reseting isBusy status
        //todo - set response message to false success
        response_message.innerText = "Try again later";
        return;
      }

      //% Deal with normal user errors
      console.error(error);

      //% Set Response
      response_message.innerText = "Something seems to have gone wrong. Please try again later";
    }

    //% Logic when form is no longer busy posting
    isBusy = false;
    form_contact.classList.remove("busy");
  };
}
